import "./Promotion.css";
import { useEffect } from "react";
// component hiển thị trang khuyến mại
const Promotion = () => {
  useEffect(() => {
    document.title = "Khuyến mại";
  });

  return (
    <div>
      <div className="position-relative bannerWrap">
        <p className="proBanner position-absolute text-uppercase text-warning fw-bold fst-italic fs-3">
          {" "}
          Vô vàn ưu đãi để nhận
        </p>
        <img className="w-100" src="/images/collection_banner.jpg" alt="" />
      </div>
      <div className="mb-3">
        <div className="newborn-wrap text-center position-relative">
          <p className="NB-text position-absolute text-success text-info fw-bold fs-2">
            Ra mắt tã dán newborn
          </p>
          <div className="imgNB-wrap">
            <img
              className="imgNB1"
              src="/images/promotion/cohoinewborn.png"
              alt=""
            />
            <img
              className="imgNB2"
              src="/images/promotion/448350458_470380055579891_267590015840468506_n.jpg"
              alt=""
            />
            <img
              className="imgNB3"
              src="/images/promotion/449057247_511242604573064_3090146076605910393_n.jpg"
              alt=""
            />
          </div>
        </div>
      </div>

      <div className="gift d-flex justify-content-center flex-column text-center">
        <p className="text-success text-info fw-bold fs-3  ">
          Nhiều phần quà hấp dẫn
        </p>
        <div>
          <img className="w-75" src="/images/promotion/bang_qua.png" alt="" />
        </div>
      </div>

      <div className="d-flex gap-2 justify-content-center flex-column text-center mt-3 mb-4">
        <p className="text-success text-info fw-bold fs-3  ">
          Nhiều chính sách ưu đãi
        </p>
        <div>
          <img
            className="w-75"
            src="/images/promotion/khach_hang_than_thiet.png"
            alt=""
          />
        </div>

        <div>
          <img className="w-75" src="/images/promotion/freeship.png" alt="" />
        </div>

        <div>
          <img className="w-75" src="/images/promotion/feedback.png" alt="" />
        </div>

        <div>
          <img className="w-75" src="/images/promotion/voucher.png" alt="" />
        </div>
      </div>
    </div>
  );
};
export default Promotion;
